'use strict';

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var injectSheet = require('react-jss');
var THEME = require('pobble-components/dist/theme');
var classNames = require('classnames');
var PropTypes = require('prop-types');
var setup = require('pobble-components/dist/setup');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var injectSheet__default = /*#__PURE__*/_interopDefaultLegacy(injectSheet);
var THEME__default = /*#__PURE__*/_interopDefaultLegacy(THEME);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var COLORS = THEME__default["default"].COLORS;
var styles = {
  environmentLine: {
    background: '#ccc',
    color: '#ccc',
    width: '100%',
    height: '7px',
    position: 'fixed',
    top: '0',
    left: '0',
    zIndex: '1000',
    pointerEvents: 'none',
    fontWeight: 'bold',
    fontSize: '8px',
    textTransform: 'uppercase'
  },
  environmentLabel: {
    display: 'block',
    height: '100%',
    padding: '0 8px',
    background: '#fff',
    position: 'absolute',
    top: '0',
    left: '10px',
    lineHeight: '1'
  },
  stg: {
    background: COLORS.PURPLE.NORMAL,
    color: COLORS.PURPLE.NORMAL
  },
  prod: {
    background: COLORS.RED.NORMAL,
    color: COLORS.RED.NORMAL
  }
};

var EnvironmentLine = function EnvironmentLine(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? setup.DOMAIN_PREFIX : _ref$prefix;
  var visible = prefix === 'stg';
  return !visible ? null : /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNames__default["default"](classes.environmentLine, _defineProperty__default["default"]({}, classes.stg, prefix === 'stg'), className)
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: classes.environmentLabel
  }, prefix));
};

EnvironmentLine.propTypes = {
  /** A given string of the current environment prefix (ex: `stg`) */
  prefix: PropTypes__default["default"].string,

  /** Additional className if you want to restyle component */
  className: PropTypes__default["default"].string
};
var index = injectSheet__default["default"](styles)(EnvironmentLine);

module.exports = index;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src2416834937/src/pobble-app/client/~/pobble-components/dist/environment-line/index.js